import axios from 'axios';
import resolve from './resolve';
import { IProfile } from '../models/IProfile';
import { URL_SERVER, URL_SPEECH } from '../utils/const';
import { store } from '../store/store';
import { setLoadingProgress } from '../store/reducers/MetersSlice';

interface testSipParams {
	lineSip?: string;
	loginSip?: string;
	passSip?: string;
	serverSip?: string;
	audioCodec?: string;
	additional_accounts_getter?: string;
}
interface testSipResp {
	statusSip: string;
	timeUpdateSip: string;
}

interface testAccountsParams {
	startDateGetter: string;
	endDateGetter: string;
	hasCalled: boolean;
}

interface testAccountsResp {
	success: boolean;
	users: [];
}

export async function testSip({
	lineSip,
	loginSip,
	passSip,
	serverSip,
}: testSipParams): Promise<any> {
	return await resolve(
		axios.get<testSipResp>(`${URL_SERVER}/users/test_sip`, {
			withCredentials: true,
			params: {
				linesSip: lineSip,
				loginSip: loginSip,
				passwordSip: passSip,
				serverSip: serverSip,
			},
		})
	);
}

export async function changeSip({
	lineSip,
	loginSip,
	passSip,
	serverSip,
	audioCodec,
	additional_accounts_getter,
}: testSipParams): Promise<any> {
	return await resolve(
		axios.get<IProfile>(`${URL_SERVER}/users/change_sip`, {
			withCredentials: true,
			params: {
				linesSip: lineSip,
				loginSip: loginSip,
				passwordSip: passSip,
				serverSip: serverSip,
				audioCodec: audioCodec,
				additional_accounts_getter,
			},
		})
	);
}

export async function activateLicence(key: string): Promise<any> {
	return await resolve(
		axios({
			withCredentials: true,
			method: 'post',
			url: `${URL_SERVER}/users/activate_licence`,
			data: { key: key },
		})
	);
}

export async function updateProfile(
	name: string,
	play_list_items: string,
	play_send_email: string,
	recording: boolean,
	play_like_text: string,
	new_url: string,
	first_text: string,
	second_text: string,
	third_text: string,
	fourth_text: string,
	confirm_text: string,
	like_text: string,
	last_text: string,
	retry_call_shop: string,
	token_access: string
): Promise<any> {
	return await resolve(
		axios.get<IProfile>(`${URL_SERVER}/users/update_profile`, {
			withCredentials: true,
			params: {
				name: name,
				play_list_items: play_list_items,
				play_send_email: play_send_email,
				recording: recording,
				play_like_text: play_like_text,
				new_url: new_url,
				first_text: first_text,
				second_text: second_text,
				third_text: third_text,
				fourth_text: fourth_text,
				confirm_text: confirm_text,
				like_text: like_text,
				last_text: last_text,
				retry_call_shop: retry_call_shop,
				token_access: token_access,
			},
		})
	);
}

export async function setTestTask(
	number: string,
	orders: string,
	email: string,
	phone: string,
	voice: string,
	token: string
): Promise<any> {
	return await resolve(
		axios.get(`${URL_SERVER}/users/tasks`, {
			withCredentials: true,
			params: {
				number: number,
				orders: orders,
				email: email,
				phone: phone,
				voice: voice,
				token: token,
			},
		})
	);
}

export async function getStatFromSpeech(key: string): Promise<any> {
	return await resolve(
		axios.get(`${URL_SPEECH}/api/get-stat`, {
			params: {
				key: key,
			},
		})
	);
}

export async function changePassword(password: string): Promise<any> {
	return await resolve(
		axios.get(`${URL_SERVER}/users/change_password`, {
			withCredentials: true,
			params: {
				password: password,
			},
		})
	);
}

export async function clearDB(): Promise<any> {
	return await resolve(
		axios.get(`${URL_SERVER}/users/clear`, {
			withCredentials: true,
		})
	);
}

export async function downloadZipFile(file: string): Promise<any> {
	return new Promise((resolve, reject) => {
		const formData = new FormData();
		formData.append('file0', file);
		const response = axios.post(`${URL_SERVER}/m_0001/import_zip`, formData, {
			withCredentials: true,
			headers: {
				'Content-Type': 'multipart/form-data',
			},
			responseType: 'stream',
			adapter: 'fetch'
		})

		response
			.then(async response => {
				for await (const chunk of response.data) {
					console.log('chunk', new TextDecoder().decode(chunk));
					store.dispatch(setLoadingProgress(Number(new TextDecoder().decode(chunk))));
				}
			})
			.then(() => resolve(true))
			.catch((error) => reject(error));
	});
}

export async function downloadExcelFile(file: string): Promise<any> {
	const formData = new FormData();
	formData.append('file0', file);
	return await resolve(
		axios.post(`${URL_SERVER}/m_0001/import`, formData, {
			withCredentials: true,
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		})
	);
}

export async function changeDisplayName(displayName: string): Promise<any> {
	return await resolve(
		axios(`${URL_SERVER}/users/change_name`, {
			method: 'post',
			withCredentials: true,
			data: {
				displayName: displayName,
			},
		})
	);
}

export async function setWarningBalance(warning: boolean): Promise<any> {
	return await resolve(
		axios(`${URL_SERVER}/users/message_balance`, {
			method: 'post',
			withCredentials: true,
			data: {
				warning: warning,
			},
		})
	);
}

export async function changeTariffUser(tariff: string): Promise<any> {
	return await resolve(
		axios(`${URL_SERVER}/users/change_tariff`, {
			method: 'post',
			withCredentials: true,
			data: {
				tariff: tariff,
			},
		})
	);
}

export async function getProfile(): Promise<any> {
	return await resolve(
		axios.get(`${URL_SERVER}/users/get_profile`, {
			withCredentials: true,
		})
	);
}

export async function getServices(): Promise<any> {
	return await resolve(
		axios.get(`${URL_SERVER}/m_0002/get_services`, {
			withCredentials: true,
		})
	);
}

export async function testAccounts({
	startDateGetter,
	endDateGetter,
	hasCalled
}: testAccountsParams): Promise<any> {
	return await resolve(
		axios.get<testAccountsResp>(`${URL_SERVER}/m_0001/check_accounts`, {
			withCredentials: true,
			params: {
				startDateGetter: startDateGetter,
				endDateGetter: endDateGetter,
				hasCalled: hasCalled
			},
		})
	);
}
